"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.developmentHybribInitializer = exports.developmentAsisInitializer = exports.developmentCCInitializer = exports.developmentDRPicasoInitializer = exports.developmentInitializer = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const translations_initializer_1 = require("../../translations/translations.initializer");
const libraries_initializer_1 = require("../../libraries/libraries.initializer");
const featureFlag_initializer_1 = require("../../featureFlag/featureFlag.initializer");
const session_initializer_1 = require("../../security/session/session.initializer");
const authoriser_initializer_1 = require("../../security/authoriser/authoriser.initializer");
const xhr_initalizer_1 = require("../../xhr/xhr.initalizer");
const authenticator_initializers_1 = require("../../security/authenticator/authenticator.initializers");
const tracker_initializer_1 = require("../../tracker/tracker.initializer");
const mobileConnector_initializer_1 = require("../../mobileConnector/mobileConnector.initializer");
const locale_initializers_1 = require("../../locale/locale.initializers");
const usd_initializer_1 = require("../../security/usd/usd.initializer");
const challengeFactory_initializer_1 = require("../../security/authoriser/challenges/challengeFactory.initializer");
const usd_1 = require("../../security/usd");
const eventBus_initializer_1 = require("../../eventBus/eventBusManager/eventBus.initializer");
const commonsInitializers = config => {
    return {
        authoriser: new authoriser_initializer_1.AuthoriserInitializer(),
        libraries: new libraries_initializer_1.LibrariesInitializer(config.libraries()),
        locale: new locale_initializers_1.LocaleInitializer(config.language),
        eventBus: new eventBus_initializer_1.EventBusInitializer(),
    };
};
const developmentInitializer = async (config) => {
    const { authoriser, libraries, locale, eventBus } = commonsInitializers(config);
    const session = new session_initializer_1.SessionInitializer(config, eventBus);
    const API = new xhr_initalizer_1.XhrInitializer(config, session, authoriser, locale);
    const authenticator = new authenticator_initializers_1.AuthenticatorInitializer(config, session, authoriser);
    const featureFlags = new featureFlag_initializer_1.FeatureFlagInitializer(config.getFeatureFlagConfig(), API);
    const translations = new translations_initializer_1.TranslationsDevInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerInitializer(config.getTrackerConfig(), API, authenticator, eventBus);
    //TODO no siempre es necesario el USD Manager pero como lo necesita uno de los challenges, lo enviamos siempre.
    //Revisar esto para que solo se creen los challenges necesarios en cada caso.
    const usd = new usd_1.MockUSDManagerInitializer();
    const challengeFactory = new challengeFactory_initializer_1.ChallengeFactoryInitializer(API, session, usd, authoriser);
    const initializers = {
        locale,
        session,
        authoriser,
        API,
        authenticator,
        libraries,
        featureFlags,
        tracker,
        translations,
        usd,
        challengeFactory,
        eventBus,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.session.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
    };
};
exports.developmentInitializer = developmentInitializer;
const developmentDRPicasoInitializer = async (config) => {
    const { authoriser, libraries, locale, eventBus } = commonsInitializers(config);
    const session = new session_initializer_1.SessionDRPicasoInitializer(config, eventBus);
    const API = new xhr_initalizer_1.XhrInitializer(config, session, authoriser, locale);
    const authenticator = new authenticator_initializers_1.AuthenticatorDRPicasoInitializer(config, session);
    const featureFlags = new featureFlag_initializer_1.FeatureFlagInitializer(config.getFeatureFlagConfig(), API);
    const translations = new translations_initializer_1.TranslationsDevInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerInitializer(config.getTrackerConfig(), API, authenticator, eventBus);
    //TODO no siempre es necesario el USD Manager pero como lo necesita uno de los challenges, lo enviamos siempre.
    //Revisar esto para que solo se creen los challenges necesarios en cada caso.
    const usd = new usd_1.MockUSDManagerInitializer();
    const challengeFactory = new challengeFactory_initializer_1.ChallengeFactoryInitializer(API, session, usd, authoriser);
    const initializers = {
        locale,
        session,
        authoriser,
        API,
        authenticator,
        libraries,
        featureFlags,
        tracker,
        translations,
        usd,
        challengeFactory,
        eventBus,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.session.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
        usd: initialized.usd.getInitialized(),
    };
};
exports.developmentDRPicasoInitializer = developmentDRPicasoInitializer;
const developmentCCInitializer = async (config) => {
    const { authoriser, libraries, locale, eventBus } = commonsInitializers(config);
    const session = new session_initializer_1.SessionUSDInitializer(config, eventBus);
    const usd = new usd_initializer_1.ModelbankUSDManagerInitializer(eventBus, session);
    const sessionDevCC = new session_initializer_1.SessionCCDevInitializer(config, eventBus);
    const sessionDRPicaso = new session_initializer_1.SessionDRPicasoInitializer(config, eventBus);
    const authenticatorDRPicaso = new authenticator_initializers_1.AuthenticatorDRPicasoInitializer(config, sessionDRPicaso);
    const authenticator = new authenticator_initializers_1.AuthenticatorCCInitializer(config, session, sessionDRPicaso, sessionDevCC, authenticatorDRPicaso, usd);
    //TODO fix this. Caused because circular dependencies
    usd.setAuthenticator(authenticator);
    const API = new xhr_initalizer_1.XhrCCInitializer(config, session, authoriser, locale);
    const featureFlags = new featureFlag_initializer_1.FeatureFlagInitializer(config.getFeatureFlagConfig(), API);
    const translations = new translations_initializer_1.TranslationsDevInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerUSDInitializer(config.getTrackerConfig(), usd, API, authenticator, eventBus);
    const challengeFactory = new challengeFactory_initializer_1.ChallengeFactoryInitializer(API, session, usd, authoriser);
    const initializers = {
        session,
        sessionDevCC,
        sessionDRPicaso,
        authenticator,
        authenticatorDRPicaso,
        locale,
        authoriser,
        API,
        libraries,
        featureFlags,
        tracker,
        translations,
        usd,
        challengeFactory,
        eventBus,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.session.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
        usd: initialized.usd.getInitialized(),
    };
};
exports.developmentCCInitializer = developmentCCInitializer;
const developmentAsisInitializer = async (config) => {
    const { authoriser, libraries, locale, eventBus } = commonsInitializers(config);
    const session = new session_initializer_1.AsisSessionInitializer(config, eventBus);
    const API = new xhr_initalizer_1.XhrInitializer(config, session, authoriser, locale);
    const authenticator = new authenticator_initializers_1.AuthenticatorInitializer(config, session, authoriser);
    const featureFlags = new featureFlag_initializer_1.FeatureFlagInitializer(config.getFeatureFlagConfig(), API);
    const translations = new translations_initializer_1.TranslationsDevInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerInitializer(config.getTrackerConfig(), API, authenticator, eventBus);
    //TODO no siempre es necesario el USD Manager pero como lo necesita uno de los challenges, lo enviamos siempre.
    //Revisar esto para que solo se creen los challenges necesarios en cada caso.
    const usd = new usd_1.MockUSDManagerInitializer();
    const challengeFactory = new challengeFactory_initializer_1.ChallengeFactoryInitializer(API, session, usd, authoriser);
    const initializers = {
        locale,
        session,
        authoriser,
        API,
        authenticator,
        libraries,
        featureFlags,
        tracker,
        translations,
        usd,
        challengeFactory,
        eventBus,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.session.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
    };
};
exports.developmentAsisInitializer = developmentAsisInitializer;
const developmentHybribInitializer = async (config) => {
    const { authoriser, libraries, locale, eventBus } = commonsInitializers(config);
    const session = new session_initializer_1.SessionInitializer(config, eventBus);
    const mobileConnector = new mobileConnector_initializer_1.MobileConnectorDevInitializer(session);
    const sessionHybrid = new session_initializer_1.SessionHybridInitializer(mobileConnector, eventBus);
    const API = new xhr_initalizer_1.XhrHybridInitializer(config, session, authoriser, locale, mobileConnector);
    const authenticator = new authenticator_initializers_1.AuthenticatorHybridInitializer(sessionHybrid, mobileConnector);
    const featureFlags = new featureFlag_initializer_1.FeatureFlagInitializer(config.getFeatureFlagConfig(), API);
    const translations = new translations_initializer_1.TranslationsDevInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerInitializer(config.getTrackerConfig(), API, authenticator, eventBus);
    //TODO no siempre es necesario el USD Manager pero como lo necesita uno de los challenges, lo enviamos siempre.
    //Revisar esto para que solo se creen los challenges necesarios en cada caso.
    const usd = new usd_1.MockUSDManagerInitializer();
    const challengeFactory = new challengeFactory_initializer_1.ChallengeFactoryInitializer(API, session, usd, authoriser);
    const initializers = {
        locale,
        session,
        sessionHybrid,
        authenticator,
        authoriser,
        API,
        libraries,
        featureFlags,
        tracker,
        translations,
        usd,
        challengeFactory,
        mobileComunicator: mobileConnector,
        eventBus,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.sessionHybrid.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
    };
};
exports.developmentHybribInitializer = developmentHybribInitializer;
//# sourceMappingURL=development.initializers.js.map